import React from "react";
// import { Link } from '@reach/router';
import { Link } from "gatsby";
import { AuthService } from "../_services/auth.service";
import { TokenService } from "../_services/token.service";
import { userService } from "../_services/user.service";

interface NavItemProps {
  item: {
    icon: string;
    link: string;
    title: string;
    page: string;
    external?: boolean;
  };
  sidebarToggle: () => void;
}

const NavItem = (props: NavItemProps) => {
  const { icon, link, title, page, external } = props.item;
  let path = window.location.pathname.split("/");
  const linkSegments = link.split("/");
  const pathLinks = linkSegments.length > 2 ? linkSegments[2] : undefined;

  const getSidebarToggle = () => {
    props?.sidebarToggle();
  };

  const mapUserKindToRole = (kind?: string): string => {
    if (!kind) {
      return 'member';
    }
    const normalizedKind = kind.toLowerCase();
    if (normalizedKind === "admin") {
      return "admin";
    }
    if (normalizedKind === "product") {
      return "product";
    }
    return 'member';
  };

  const capitalizeWords = (text: string): string => {
    return text
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  const handleExternalLinkClick = async (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    
    const user = TokenService.getUser();
    if (!user) {
      console.error("User not authenticated");
      getSidebarToggle();
      return;
    }
    
    // Get username - fetch if needed
    let username = 'Unknown User';
    if (user.firstname && user.lastname) {
      username = `${user.firstname} ${user.lastname}`;
    } else if (user.username) {
      // Fetch user details to get the full name
      const usernameFromLogin = user.username || AuthService.getUsername();
      try {
        const respUser = await userService.getUser(usernameFromLogin);
        if (respUser?.status === 200 && respUser?.data) {
          TokenService.updateLocalUser(respUser.data);
          // Get updated user with first and last name
          const updatedUser = TokenService.getUser();
          if (updatedUser.firstname && updatedUser.lastname) {
            username = `${updatedUser.firstname} ${updatedUser.lastname}`;
          } else {
            username = user.username;
          }
        } else {
          username = user.username;
        }
      } catch (error) {
        console.error("Failed to fetch user details:", error);
        username = user.username;
      }
    }
    
    // Capitalize and open dashboard
    username = capitalizeWords(username);
    const params = new URLSearchParams();
    params.set("username", username);
    params.set("role", mapUserKindToRole(user.kind));
    const url = `${link}?${params.toString()}`;
    
    const newWindow = window.open(url, "_blank");
    if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
      console.warn("Popup blocked. Please allow popups.");
    }
    
    getSidebarToggle();
  };

  const isOwnAnyProduct = (page: string): boolean => {
    if (page !== "dashboard") {
      return true;
    }
    
    const user = AuthService.getCurrentUser();
    if (!user?.roles) {
      return false;
    }
    
    return user.roles.some((item: any) => item?.role === "Owner");
  };

  const renderNavContent = () => (
    <>
      <i className={icon + " navIcon"} aria-hidden="true"></i>
      <span className="navLabel">{title} </span>
    </>
  );
  
  return (
    <div onClick={!external ? getSidebarToggle : undefined}>
      {
       AuthService.hasAccess(page) && isOwnAnyProduct(page) ? (
        external ? (
          <a
            href={link}
            onClick={handleExternalLinkClick}
            className="navItem"
            target="_blank"
            rel="noopener noreferrer"
          >
            {renderNavContent()}
          </a>
        ) : (
          <Link
            to={link}
            className={
              pathLinks && path.indexOf(pathLinks) > -1 ? "navItem active" : "navItem"
            }
            activeClassName="active"
          >
            {renderNavContent()}
          </Link>
        )
      ):null
    }
    </div>
  );
};

export default NavItem;
